export const modelVendor = {
  OPENAI: "OPENAI",
  ANTHROPIC: "ANTHROPIC",
  NEBIUS: "NEBIUS",
  AMAZON: "AMAZON",
  META: "META",
};

export const openAIModel = {
  GPT3: "system:openai-gpt3.5",
};

export const currentModelDescriptions = [
  {
    id: "direct:openai.gpt4o",
    name: "GPT-4o",
    vendor: modelVendor.OPENAI,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:openai.gpt4.1",
    name: "GPT-4.1",
    vendor: modelVendor.OPENAI,
    contextWindow: "1M",
    icon: "",
  },
  {
    id: "direct:openai.gpt5-instant",
    name: "GPT-5 Instant",
    vendor: modelVendor.OPENAI,
    contextWindow: "400k",
    icon: "",
  },
  {
    id: "direct:openai.gpt5-thinking",
    name: "GPT-5 Thinking",
    vendor: modelVendor.OPENAI,
    contextWindow: "400k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:openai.gpt5-mini",
    name: "GPT-5 mini",
    vendor: modelVendor.OPENAI,
    contextWindow: "400k",
    icon: "",
  },
  {
    id: "direct:openai.gpt5-mini-thinking",
    name: "GPT-5 mini Thinking",
    vendor: modelVendor.OPENAI,
    contextWindow: "400k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:openai.gpt5-nano",
    name: "GPT-5 nano",
    vendor: modelVendor.OPENAI,
    contextWindow: "400k",
    icon: "",
  },
  {
    id: "direct:openai.gpt5-nano-thinking",
    name: "GPT-5 nano Thinking",
    vendor: modelVendor.OPENAI,
    contextWindow: "400k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:anthropic.claude-4.5-sonnet",
    name: "Claude Sonnet 4.5",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    icon: "",
  },
  {
    id: "direct:anthropic.claude-4.5-sonnet-thinking",
    name: "Claude Sonnet 4.5 Extended Thinking",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:anthropic.claude-4.1-opus",
    name: "Claude Opus 4.1",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    icon: "",
  },
  {
    id: "direct:anthropic.claude-4.1-opus-thinking",
    name: "Claude Opus 4.1 Extended Thinking",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:anthropic.claude-4-sonnet",
    name: "Claude Sonnet 4",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    icon: "",
  },
  {
    id: "direct:anthropic.claude-4-sonnet-thinking",
    name: "Claude Sonnet 4 Extended Thinking",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:anthropic.claude-3.7-sonnet",
    name: "Claude Sonnet 3.7",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    icon: "",
  },
  {
    id: "direct:anthropic.claude-3.7-sonnet-thinking",
    name: "Claude Sonnet 3.7 Extended Thinking",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:nebius.deepseek-ai/DeepSeek-R1-0528",
    name: "DeepSeek-R1-0528",
    vendor: modelVendor.NEBIUS,
    contextWindow: "164k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:nebius.deepseek-ai/DeepSeek-R1-0528-fast",
    name: "DeepSeek-R1-0528 Fast",
    vendor: modelVendor.NEBIUS,
    contextWindow: "164k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:nebius.deepseek-ai/DeepSeek-V3-0324",
    name: "DeepSeek-V3-0324",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.deepseek-ai/DeepSeek-V3-0324-fast",
    name: "DeepSeek-V3-0324 Fast",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.moonshotai/Kimi-K2-Instruct",
    name: "Kimi-K2-Instruct",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.zai-org/GLM-4.5-thinking",
    name: "GLM-4.5 Thinking",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:nebius.Qwen/Qwen3-235B-A22B-Instruct-2507",
    name: "Qwen3-235B-A22B-Instruct-2507",
    vendor: modelVendor.NEBIUS,
    contextWindow: "262k",
    icon: "",
  },
  {
    id: "direct:nebius.Qwen/Qwen3-235B-A22B-Thinking-2507",
    name: "Qwen3-235B-A22B-Thinking-2507",
    vendor: modelVendor.NEBIUS,
    contextWindow: "262k",
    reasoning: true,
    icon: "",
  },
  {
    id: "direct:nebius.meta-llama/Meta-Llama-3.1-8B-Instruct",
    name: "Llama-3.1-8B-Instruct",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.meta-llama/Meta-Llama-3.1-8B-Instruct-fast",
    name: "Llama-3.1-8B-Instruct Fast",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.meta-llama/Llama-3.3-70B-Instruct",
    name: "Llama-3.3-70B-Instruct",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.meta-llama/Llama-3.3-70B-Instruct-fast",
    name: "Llama-3.3-70B-Instruct Fast",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "direct:nebius.meta-llama/Meta-Llama-3.1-405B-Instruct",
    name: "Llama-3.1-405B-Instruct",
    vendor: modelVendor.NEBIUS,
    contextWindow: "128k",
    icon: "",
  },
];

const modelDescriptors = [
  /*
  {
    id: "system:openai-gpt3.5",
    name: "GPT 3.5 (Deprecated)",
    vendor: modelVendor.OPENAI,
    icon: "",
  },
  */
  {
    id: "system:openai-gpt4",
    name: "GPT-4",
    vendor: modelVendor.OPENAI,
    contextWindow: "8k",
    icon: "",
  },
  {
    id: "system:openai-gpt4-turbo",
    name: "GPT-4 Turbo",
    vendor: modelVendor.OPENAI,
    contextWindow: "128k",
    icon: "",
  },
  {
    id: "system:claude-v2",
    name: "Claude 2",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "100k",
    icon: "",
  },
  {
    id: "system:claude-v2.1",
    name: "Claude 2.1",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "200k",
    icon: "",
  },
  {
    id: "system:claude-instant-v1",
    name: "Claude Instant 1.2",
    vendor: modelVendor.ANTHROPIC,
    contextWindow: "100k",
    icon: "",
  },
  /*{
    id: "system:openai-gpt4-32k",
    name: "GPT-4 32k",
    vendor: modelVendor.OPENAI,
    contextWindow: "32k",
    icon: "",
  },*/
  {
    id: "system:openai-chatgpt",
    name: "GPT 3.5",
    vendor: modelVendor.OPENAI,
    contextWindow: "4k",
    icon: "",
  },
  {
    id: "system:amazon.titan-text-express-v1",
    name: "Titan Text G1 - Express",
    vendor: modelVendor.AMAZON,
    contextWindow: "8k",
    icon: "",
  },
  {
    id: "system:amazon.titan-text-lite-v1",
    name: "Titan Text G1 - Lite",
    vendor: modelVendor.AMAZON,
    contextWindow: "4k",
    icon: "",
  },
  /*
  {
    id: "system:meta.llama2-70b-chat-v1",
    name: "Llama 2 Chat 70B",
    vendor: modelVendor.META,
    contextWindow: "4k",
    icon: "",
  },
  {
    id: "system:meta.llama2-70b-v1",
    name: "Llama 2 70B",
    vendor: modelVendor.META,
    contextWindow: "4k",
    icon: "",
  },
  */
];

export const getDescriptorById = (id) =>
  modelDescriptors.find((item) => item.id === id);

export default modelDescriptors;
